<div class="flex flex-col h-full">
  <mat-toolbar color="primary" class="!hidden sm:!flex" >
    <!-- show on search page or in tablet or desktop view -->
    <mat-toolbar-row>
      <a class="app-name-header" routerLink="/home">Corpers NG</a>
      <span class="toolbar-spacer"></span>

      <ng-container *ngIf="this.baseService.isLoggedIn">
        <button
        type="button"
        class="hide-mobile"
        mat-button
        (click)="openAddNewPPADialog()"
      >
        Add PPA
      </button>

      <button
        type="button"
        class="hide-mobile"
        mat-button
        (click)="openCreateAccommodationPostDialog()"
      >
        Post Accommodation
      </button>

      <button
        type="button"
        class="hide-mobile"
        mat-button
        (click)="openCreateSalePostDialog()"
      >
        Post Sale
      </button>
      </ng-container>

      <button
        type="button"
        class="hide-mobile"
        color="accent"
        mat-stroked-button
        [matMenuTriggerFor]="menu"
      >
        Menu
      </button>

      <button
        type="button"
        mat-icon-button
        (menuOpened)="toggleMenuState()"
        (menuClosed)="toggleMenuState()"
        [matMenuTriggerFor]="menu"
        class="hide-desktop"
      >
        <mat-icon class="nav-icon" aria-label="menu icon"
          >menu{{ menuState }}</mat-icon
        >
      </button>

      <mat-menu #menu="matMenu" class="menu-list">
        <button type="button" mat-menu-item [routerLink]="['/home']">
          <mat-icon fontSet="material-icons-outlined">home</mat-icon> Home
        </button>
        <button
          *ngIf="baseService.isLoggedIn"
          type="button"
          mat-menu-item
          [routerLink]="['/dashboard']"
        >
        <mat-icon fontSet="material-icons-outlined">dashboard</mat-icon> Dashboard
        </button>
        <button
          *ngIf="baseService.isLoggedIn"
          type="button"
          mat-menu-item
          [routerLink]="['/messages']"
        >
          <mat-icon
            matBadgePosition="after"
            matBadgeOverlap="true"
            [matBadgeHidden]="unreadMessage === 0"
            matBadgeColor="accent"
            [matBadge]="unreadMessage"
            fontSet="material-icons-outlined"
            >chat</mat-icon
          >
          <p>Messages</p>
        </button>
        <button
          *ngIf="baseService.isLoggedIn"
          type="button"
          mat-menu-item
          [routerLink]="['/profile']"
        >
        <mat-icon [fontSet]="unreadMessage === 0 ? 'material-icons' : 'material-icons-outlined'">account_circle</mat-icon> Profile
        </button>
        <!-- TODO: should (people, places, things) as a sub tiny texts? -->
        <button type="button" mat-menu-item [routerLink]="['/search']">
          <mat-icon>search</mat-icon> Search
        </button>
        <button
          *ngIf="baseService.isLoggedIn"
          type="button"
          mat-menu-item
          (click)="logout()"
        >
        <mat-icon>logout</mat-icon> Logout
        </button>
      </mat-menu>
    </mat-toolbar-row>
  </mat-toolbar>

  <div class="flex-1 overflow-auto">
    <router-outlet></router-outlet>
  </div>

  <!-- Hide with css -->
  <mat-toolbar color="primary" class="sm:!hidden" >
    <mat-toolbar-row class="justify-between">
      <button
        type="button"
        routerLinkActive="text-white"
        mat-menu-button
        [routerLink]="['/home']"
      >
        <mat-icon>home</mat-icon>
        <p class="mb-0 text-xs -mt-2.5">Home</p>
      </button>

      <!-- <button type="button" mat-icon-button (click)="openAddNewPPADialog()">
        <mat-icon aria-label="create new accommodation icon">add_home_work</mat-icon>
      </button> -->

      <button
        type="button"
        mat-menu-button
        routerLinkActive="text-white"
        [routerLink]="['/search']"
      >
        <mat-icon
          class="!fill-slate-950"
          aria-label="create new accommodation icon"
          >search</mat-icon
        >
        <p class="mb-0 text-xs -mt-2.5">Search</p>
      </button>

      <button type="button" mat-menu-button (click)="openAddNewPPADialog()">
        <mat-icon aria-label="create new sale icon">new_label</mat-icon>
        <p class="mb-0 text-xs -mt-2.5">Add PPA</p>
      </button>

      <button type="button" mat-menu-button routerLinkActive="text-white"
        [routerLink]="['/dashboard']">
        <mat-icon aria-label="dashboard icon">dashboard</mat-icon>
        <p class="mb-0 text-xs -mt-2.5">Dashboard</p>
      </button>

      <button
        *ngIf="baseService.isLoggedIn"
        routerLinkActive="text-white"
        type="button"
        mat-menu-button
        [routerLink]="['/messages']"
      >
        <mat-icon
          matBadgePosition="after"
          matBadgeOverlap="true"
          [matBadgeHidden]="unreadMessage === 0"
          matBadgeColor="accent"
          [matBadge]="unreadMessage"
          >chat</mat-icon
        >
        <p class="mb-0 text-xs -mt-2.5">Chats</p>
      </button>

      <button
        type="button"
        mat-menu-button
        routerLinkActive="text-white"
        [routerLink]="['/profile']"
      >
        <mat-icon>person</mat-icon>
        <p class="mb-0 text-xs -mt-2.5">Profile</p>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>
</div>
